/** Shared GraphQL selection set for towing order line items */
export const ORDER_ITEMS_QUERY_FIELDS = `
  itemsIncludeVat
  orderItems {
    id
    type
    name
    description
    quantity
    unitPrice
    unitPriceHasVatIncluded
    unit
    vat
    discountType
    discount
    netAmount
    grossAmount
    vatAmount
    vatUnit
    vatCategory
  }
  discountItem {
    id
    type
    name
    description
    quantity
    unitPrice
    unitPriceHasVatIncluded
    unit
    vat
    discountType
    discount
    netAmount
    grossAmount
    vatAmount
    vatUnit
    vatCategory
  }
`
